import { IHomeOperation, IOperation, OPERATION_TYPE } from '../../operations/models/operations.models';
import { IWorkflowDetailResponse } from '../models/workflows.models';

/**
 * Utilidades HOME del editor de workflows (NIF-530).
 *
 * Abrir cuando: localizar la op HOME en el detalle o serializar `policy_checks` al API.
 * Sin dependencias Angular — puro y testeable.
 */

/**
 * Busca la operación HOME en el detalle del workflow.
 *
 * @param detail - Respuesta de detalle (o parcial con `operations`)
 */
export function findHomeOperation(
	detail: Pick<IWorkflowDetailResponse, 'operations'> | undefined,
): IHomeOperation | undefined {
	return detail?.operations?.find((op: IOperation) => op.type === OPERATION_TYPE.HOME) as
		| IHomeOperation
		| undefined;
}

/**
 * Serializa `policy_checks` del form → solo `uuid` para el API.
 * Lista vacía / ausente → `undefined` (no se envía la clave).
 *
 * @param policyChecks - Filas del FormArray HOME
 */
export function serializeHomePolicyChecks(
	policyChecks: Array<{ uuid?: string }> | null | undefined,
): Array<{ uuid?: string }> | undefined {
	if (!policyChecks?.length) {
		return undefined;
	}
	return policyChecks.map((check) => ({ uuid: check?.uuid }));
}
